import { createSlice } from "@reduxjs/toolkit";
import {
  getCourseById,
  getCoursesByUser,
  getFeaturedCourses,
  getFreeVideos,
  getPromoCourses,
  getPurchasedCourseBySlug,
  getPurchasedVideoById,
} from "./courseService";

const initialState = {
  featuredCourses: {
    isCoursesLoading: null,
    courseMessage: null,
    isCoursesSuccess: null,
    pageCount: null,
    courses: [],
  },
  course: {
    isCourseLoading: null,
    courseMessage: null,
    isCourseSuccess: null,
    courseDetails: null,
    lessons: [],
  },
  purchasedCourses: {
    isPurchasedCoursesLoading: null,
    purchasedCourseMessage: null,
    isPurchasedCoursesSuccess: null,
    pageCount: null,
    purchasedCourses: [],
  },
  purchasedVideo: {
    isPurchasedVideoLoading: null,
    purchasedVideoMessage: null,
    isPurchasedVideoSuccess: null,
    purchasedVideo: null,
  },
  promoCourses: {
    isPromoCoursesLoading: null,
    promoCourseMessage: null,
    isPromoCoursesSuccess: null,
    promoCourses: [],
  },
  freeVideos: {
    isFreeVideosLoading: null,
    freeVideosMessage: null,
    isFreeVideosSuccess: null,
    freeVideos: [],
  },
  purchasedCourse: {
    isPurchasedCourseLoading: null,
    isPurchasedCourseSuccess: null,
    purchasedCourse: null,
  },
};

const courseSlice = createSlice({
  name: "course",
  initialState,
  reducers: {
    resetPurchasedCourses(state) {
      state.purchasedCourses = [];
      state.isPurchasedCoursesLoading = false;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(getFeaturedCourses.pending, (state) => {
        state.featuredCourses = {
          ...initialState.featuredCourses,
          isCoursesLoading: true,
          courseMessage: "Fetching the courses...",
        };
      })
      .addCase(getFeaturedCourses.rejected, (state, action) => {
        state.featuredCourses = {
          ...initialState.featuredCourses,
          isCoursesLoading: false,
          isCoursesSuccess: false,
          courseMessage: action.payload.message,
        };
      })
      .addCase(getFeaturedCourses.fulfilled, (state, action) => {
        state.featuredCourses = {
          ...initialState.featuredCourses,
          isCoursesLoading: false,
          isCoursesSuccess: true,
          courseMessage: action.payload.message,
          pageCount: action.payload.pageCount,
          courses: action.payload.data,
        };
      });

    builder
      .addCase(getCourseById.pending, (state) => {
        state.course = {
          ...initialState.course,
          isCourseLoading: true,
          courseMessage: "Fetching the course...",
        };
      })
      .addCase(getCourseById.rejected, (state, action) => {
        state.course = {
          ...initialState.course,
          isCourseLoading: false,
          isCourseSuccess: false,
          courseMessage: action.payload.message,
        };
      })
      .addCase(getCourseById.fulfilled, (state, action) => {
        state.course = {
          ...initialState.course,
          isCourseLoading: false,
          isCourseSuccess: true,
          courseMessage: "Successfully retrieved the course details",
          courseDetails: action.payload,
          lessons: action.payload.sub_titles,
        };
      });

    builder
      .addCase(getCoursesByUser.pending, (state) => {
        state.purchasedCourses = {
          ...initialState.purchasedCourses,
          isPurchasedCoursesLoading: true,
          purchasedCourseMessage: "Fetching the courses...",
        };
      })
      .addCase(getCoursesByUser.rejected, (state, action) => {
        state.purchasedCourses = {
          ...initialState.purchasedCourses,
          isPurchasedCoursesLoading: false,
          isPurchasedCoursesSuccess: false,
          purchasedCourseMessage: action.payload.message,
        };
      })
      .addCase(getCoursesByUser.fulfilled, (state, action) => {
        state.purchasedCourses = {
          ...initialState.purchasedCourses,
          isPurchasedCoursesLoading: false,
          isPurchasedCoursesSuccess: true,
          purchasedCourseMessage: action.payload.message,
          pageCount: action.payload.pageCount,
          purchasedCourses: action.payload,
        };
      });

    builder
      .addCase(getPurchasedVideoById.pending, (state) => {
        state.purchasedVideo = {
          ...initialState.purchasedVideo,
          isPurchasedVideoLoading: true,
          purchasedVideoMessage: "Fetching the courses...",
        };
      })
      .addCase(getPurchasedVideoById.rejected, (state, action) => {
        state.purchasedVideo = {
          ...initialState.purchasedVideo,
          isPurchasedVideoLoading: false,
          isPurchasedVideoSuccess: false,
          purchasedVideoMessage: action.payload.message,
        };
      })
      .addCase(getPurchasedVideoById.fulfilled, (state, action) => {
        state.purchasedVideo = {
          ...initialState.purchasedVideo,
          isPurchasedVideoLoading: false,
          isPurchasedVideoSuccess: true,
          purchasedVideoMessage: action.payload.message,
          purchasedVideo: action.payload,
        };
      });

       builder
      .addCase(getPromoCourses.pending, (state) => {
        state.promoCourses = {
          ...initialState.promoCourses,
          isPromoCoursesLoading: true,
          promoCourseMessage: "Fetching the courses...",
        };
      })
      .addCase(getPromoCourses.rejected, (state, action) => {
        state.promoCourses = {
          ...initialState.promoCourses,
          isPromoCoursesLoading: false,
          isPromoCoursesSuccess: false,
          promoCourseMessage: action.payload.message,
        };
      })
      .addCase(getPromoCourses.fulfilled, (state, action) => {
        state.promoCourses = {
          ...initialState.promoCourses,
          isPromoCoursesLoading: false,
          isPromoCoursesSuccess: true,
          promoCourseMessage: action.payload.message,
          promoCourses: action.payload.data,
        };
      });

      builder
      .addCase(getFreeVideos.pending, (state) => {
        state.freeVideos = {
          ...initialState.freeVideos,
          isFreeVideosLoading: true,
          freeVideosMessage: "Fetching the free videos...",
        };
      })
      .addCase(getFreeVideos.rejected, (state, action) => {
        state.freeVideos = {
          ...initialState.freeVideos,
          isFreeVideosLoading: false,
          isFreeVideosSuccess: false,
          freeVideosMessage: action.payload.message,
        };
      })
      .addCase(getFreeVideos.fulfilled, (state, action) => {
        state.freeVideos = {
          ...initialState.freeVideos,
          isFreeVideosLoading: false,
          isFreeVideosSuccess: true,
          freeVideosMessage: action.payload.message,
          freeVideos: action.payload.data,
        };
      });

      
    builder
      .addCase(getPurchasedCourseBySlug.pending, (state) => {
        state.purchasedCourse = {
          ...initialState.purchasedCourse,
          isPurchasedCourseLoading: true,
        };
      })
      .addCase(getPurchasedCourseBySlug.rejected, (state, action) => {
        state.purchasedCourse = {
          ...initialState.purchasedCourse,
          isPurchasedCourseLoading: false,
          isPurchasedCourseSuccess: false,
        };
      })
      .addCase(getPurchasedCourseBySlug.fulfilled, (state, action) => {
        state.purchasedCourse = {
          ...initialState.purchasedCourse,
          isPurchasedCourseLoading: false,
          isPurchasedCourseSuccess: true,
          purchasedCourse: action.payload,
        };
      });
  },
});

export const { resetPurchasedCourses } = courseSlice.actions;
export default courseSlice.reducer;
